import {
  createAsyncAction,
  createStandardAction,
} from 'typesafe-actions';

import { IClip } from '../api';
import {
  IMediaEvent,
  ISeekTarget,
} from '../lib/AudiostorePlayer';

export const mediaEvent = createStandardAction('MEDIA_EVENT')<IMediaEvent>();
export const timeUpdate = createStandardAction('TIME_UPDATE')<number>();
export const playerSeek = createStandardAction('PLAYER_SEEK')<ISeekTarget>();
export const setPlaying = createStandardAction('SET_PLAYING')<boolean>();
export const playerError = createStandardAction('PLAYER_ERROR')<MediaError>();

export const togglePlaybackRate = createStandardAction('TOGGLE_PLAYBACK_RATE')();
export const toggleWaveform = createStandardAction('TOGGLE_WAVEFORM')();

export const playClip = createAsyncAction(
  'PLAY_CLIP_REQUEST',
  'PLAY_CLIP_SUCCESS',
  'PLAY_CLIP_FAILURE',
)<IClip, void, Error>();



// WEBPACK FOOTER //
// ./src/actions/playerActions.ts